import { UseTellescopeQueryOptions } from "../../types";
import { useTellescopeQuery } from "../../use-tellescope-query";

export interface FHIRPractitioner {
  resourceType: "Practitioner";
  id: string;
  identifier?: {
    system: string;
    value: string;
  }[];
  name?: {
    use?: string;
    text?: string;
    family?: string;
    given?: string[];
  }[];
  address?: {
    use?: string;
    line?: string[];
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
  }[];
  telecom?: {
    id?: string;
    system?: string;
    value?: string;
    use?: string;
    rank?: number;
  }[];
  qualification?: {
    identifier?: {
      system: string;
      value: string;
    }[];
    code?: {
      text: string;
    };
    period?: {
      start?: string;
      end?: string;
    };
    issuer?: {
      extension?: {
        url: string;
        valueString: string;
      }[];
      display?: string;
    };
  }[];
}

export interface CanvasPractitionersBundle {
  resourceType: "Bundle";
  type: "searchset";
  total: number;
  link?: {
    relation: string;
    url: string;
  }[];
  entry?: {
    resource: FHIRPractitioner;
  }[];
}

export interface UseCanvasPractitionersQueryOptions<TError = Error, TData = { data: CanvasPractitionersBundle }>
  extends Omit<
    UseTellescopeQueryOptions<"integrations", "proxy_read", TError, TData>,
    "model" | "method" | "request"
  > {}

export const useCanvasPractitionersQuery = <TError = Error, TData = { data: CanvasPractitionersBundle }>(
  options: UseCanvasPractitionersQueryOptions<TError, TData> = {}
) =>
  useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Canvas",
      type: "practitioners",
    },
    ...options,
  });
